<template>
<svg data-svg-lvl-2="flyleaffront-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430">
<PreviewLayersFlyleaffrontBlockShadowDHL :params="params" v-if="!params.isFlap7" />
<PreviewLayersFlyleaffrontBlockShadowDHL_F7 :params="params" v-if="params.isFlap7" />
<PreviewLayersFlyleaffrontBlockFlyleaffrontDHL :params="params" v-if="!params.isFlap7" />
<PreviewLayersFlyleaffrontBlockFlyleaffrontDHL_F7 :params="params" v-if="params.isFlap7" />
<PreviewLayersFlyleaffrontBlockContourDHL :params="params" v-if="!params.isFlap7" />
<PreviewLayersFlyleaffrontBlockContourDHL_F7 :params="params" v-if="params.isFlap7" />
<PreviewLayersFlyleaffrontBlockPocketR :params="params" v-if="params.flyleaffrontPocket" />
<PreviewDraggableInner :params="params" />
</svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default { components: {
      PreviewDraggableInner: () => import('/src/components/preview/DraggableInner'),
     },props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>